function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0-9"
}, /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 23,
  fill: "#fff"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-205.31 -102.78)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.26458 0 0 .26458 182.74 99.1)",
  fill: "none"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(46.76 -5.1174)",
  fill: "none"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(34.733 19.027)",
  fill: "none"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0-9)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m7.6663 23c2.116 0 3.8334-1.7173 3.8334-3.8333v-3.8333h-3.8334c-2.116 0-3.8333 1.7173-3.8333 3.8333s1.7173 3.8333 3.8333 3.8333z",
  fill: "#0acf83"
}), /*#__PURE__*/React.createElement("path", {
  d: "m3.833 11.5c0-2.116 1.7173-3.8334 3.8333-3.8334h3.8334v7.6666h-3.8334c-2.116 0-3.8333-1.7173-3.8333-3.8333z",
  fill: "#a259ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m3.833 3.8333c0-2.116 1.7173-3.8333 3.8333-3.8333h3.8334v7.6667h-3.8334c-2.116 0-3.8333-1.7173-3.8333-3.8333z",
  fill: "#f24e1e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m11.5 0h3.8333c2.116 0 3.8334 1.7173 3.8334 3.8333s-1.7174 3.8333-3.8334 3.8333h-3.8333z",
  fill: "#ff7262"
}), /*#__PURE__*/React.createElement("path", {
  d: "m19.167 11.5c0 2.116-1.7174 3.8333-3.8334 3.8333s-3.8333-1.7173-3.8333-3.8333c0-2.116 1.7173-3.8334 3.8333-3.8334s3.8334 1.7173 3.8334 3.8334z",
  fill: "#1abcfe"
}))))));

function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4.057mm",
    height: "6.0854mm",
    viewBox: "0 0 4.057 6.0854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.69839f81.svg";
export { ForwardRef as ReactComponent };